export { GlobalStyles } from './GlobalStyles';
export { palette } from './primitives/palette';
